// Module
var code = "<div class=\"wrapper\"> <label for=\"superadmin-jumper-lot\">Lot</label> <input name=\"superadmin-jumper-lot\" id=\"superadmin-jumper-lot\" class=\"form-control\"> </div> ";
// Exports
module.exports = code;